import { useSignOut } from '../hooks/useAuth'

/**
 * Shown when a session is valid but the API refuses it — the login has no
 * employee link, or the linked team member was deactivated. The auth
 * middleware 403s every `/api/*` call in that state, but `/api/auth/*` skips
 * the middleware, so the session check alone still says "signed in". Without
 * this screen the app would render a full shell with every panel erroring.
 */
export function AccountNotLinked({ reason }: { reason: 'not_linked' | 'deactivated' }) {
  const signOut = useSignOut()

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="sidebar-brand-icon">×</div>
          <h1>
            double<span style={{ color: 'var(--accent-primary)' }}>·</span>xl
          </h1>
          <p className="text-muted">Studio OS</p>
        </div>

        <p className="text-muted" style={{ marginBottom: 'var(--space-4)' }}>
          {reason === 'deactivated'
            ? 'This account has been deactivated. If that looks wrong, ask an admin to reactivate you.'
            : 'This login isn’t linked to a team member yet, so there’s nothing to show. Ask an admin to set up your access.'}
        </p>

        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => signOut.mutate()}
          disabled={signOut.isPending}
        >
          {signOut.isPending ? 'Signing out…' : 'Sign out'}
        </button>
      </div>
    </div>
  )
}
